<template>
  <p><button class="wechat" type="button" @click="signIn">{{ t('button-wechat-sign-in') }}</button></p>
</template>

<script>
import { t } from '@/texts';
import { authorize } from './wechat';

export default {
  name: 'WeChatSignInButton',
  methods: {
    t,
    signIn() { authorize('snsapi_base', this.$route.query.next); },
  },
};
</script>
